module.exports = __webpack_public_path__ + "static/img/2.c5420bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/2.png
// module id = PirA
// module chunks = 0